import Vue from "vue";
import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    model: {
      destinationStoreInfoCommand: { storeId: null, storeName: "" },
      storeId: null,
      requesterInfoCommand: { requesterId: "1", requesterName: "Admin" },
      registerClock: null,
      automationCode: null,
      description: null,
      checkType: 0,
      inventoryTransactionItemCommands: [],
    },
    selectedTransactionIndex: null,
    details: [],
    selectedTransactionCount: null,
  },
  getters: {
    model: (state) => state.model,
    inventoryTransactions: (state) =>
      state.model.inventoryTransactionItemCommands,
    selectedTransactionSerials: (state) => {
      var transaction =
        state.model.inventoryTransactionItemCommands[
          state.selectedTransactionIndex
        ];
      return transaction && transaction.serialsInfo
        ? transaction.serialsInfo
        : [];
    },
    selectedTransactionSerialsCountLessThanEnteredCount: (state) => {
      var transaction =
        state.model.inventoryTransactionItemCommands[
          state.selectedTransactionIndex
        ];
      return transaction && transaction.serialsInfo
        ? transaction.serialsInfo.length < transaction.count
        : true;
    },
    details: (state) => state.details,
    selectedTransactionCount: (state) => state.selectedTransactionCount,
  },
  actions: {
    create({ state }) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Inventory/api/TransferTransactions", state.model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    update({ commit, dispatch }, model) {
      return ajax
        .put("WarehousingManagement/api/Warehouses", model)
        .then(() => {
          dispatch("fetch");
        });
    },
    setModelHeaders({ commit }, model) {
      commit("setModelHeaders", model);
    },
    addTransaction({ commit, dispatch }, transaction) {
      commit("addTransaction", transaction);
    },
    addSerialToSelectedTransaction({ commit }, name) {
      commit("addSerialToSelectedTransaction", name);
    },
    removeSerialFromSelectedTransaction({ commit }, index) {
      commit("removeSerialFromSelectedTransaction", index);
    },
    setSelectedTransactionIndex({ commit }, index) {
      commit("setSelectedTransactionIndex", index);
    },
    ////////
    fetchSingle({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Inventory/api/TransferTransactionsQuery/" + id)
          .then((r) => {
            commit("setDetails", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
  },
  mutations: {
    setModelEmpty(state) {
      state.model = {
        destinationStoreInfoCommand: { storeId: null, storeName: "" },
        storeId: null,
        requesterInfoCommand: { requesterId: "1", requesterName: "Admin" },
        registerClock: null,
        automationCode: null,
        description: null,
        checkType: 0,
        inventoryTransactionItemCommands: [],
      };
    },
    setModelHeaders(state, data) {
      state.model = {
        ...state.model,
        storeId: data.storeId,
        destinationStoreInfoCommand: data.destinationStoreInfoCommand,
        registerClock: data.registerClock,
        automationCode: data.automationCode,
        requesterInfoCommand: data.requesterInfoCommand,
        description: data.description,
      };
    },
    addTransaction(state, data) {
      state.model.inventoryTransactionItemCommands.push(data);
    },
    setIndexForSerial(transaction) {
      for (let index = 0; index < transaction.length; index++) {
        const element = array[index];
      }
    },
    addSerialToSelectedTransaction(state, name) {
      var transaction =
        state.model.inventoryTransactionItemCommands[
          state.selectedTransactionIndex
        ];
      if (!transaction.serialsInfo) transaction.serialsInfo = [];
      // this.setIndexForSerial(transaction);
      var test = { serial: name, index: 1 };
      transaction.serialsInfo.push(test);
      Vue.set(
        state.model.inventoryTransactionItemCommands,
        state.selectedTransactionIndex,
        transaction
      );
    },
    removeSerialFromSelectedTransaction(state, index) {
      var transaction =
        state.model.inventoryTransactionItemCommands[
          state.selectedTransactionIndex
        ];
      if (transaction && transaction.serialsInfo) {
        transaction.serialsInfo.splice(index, 1);
        Vue.set(
          state.model.inventoryTransactionItemCommands,
          state.selectedTransactionIndex,
          transaction
        );
      }
    },
    setSelectedTransactionIndex(state, index) {
      state.selectedTransactionIndex = index;
      // set selected count also
      state.selectedTransactionCount =
        state.model.inventoryTransactionItemCommands[index].count;
    },
    setDetails(state, data) {
      state.details = data;
    },
  },
};
